import { mapMutations, mapGetters } from 'vuex';
import { dynamicParameter } from './service/mixin-service';

export default function (name, path, defaultValue) {
  const getPath = dynamicParameter(path);
  const getDefault = dynamicParameter(defaultValue);

  return {
    computed: {
      ...mapGetters('formData', ['getFormData']),

      [name]: {
        get() {
          const dataPath = getPath(this).split('.').filter(path => path);

          let currentProp = this.getFormData;

          dataPath.forEach((pathNode) => {
            if (currentProp != undefined) currentProp = currentProp[pathNode];
          });

          return currentProp === undefined ? getDefault(this) : currentProp;
        },
        set(newValue) {
          this.setFormDataField({
            targetFieldPath: getPath(this),
            value: newValue
          });
        }
      }
    },
    methods: {
      ...mapMutations('formData', ['setFormDataField'])
    }
  }
}